import { render } from "./SVGTGIcon.vue?vue&type=template&id=62c76752"
import script from "./SVGTGIcon.vue?vue&type=script&lang=js"
export * from "./SVGTGIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__